import {getStowAssociateMetrics, getStowPackageMetrics, getStowRoutes} from "../resources/StowResource";
import {publishCount, publishTime} from "../MetricUtility";
import {ERROR_METRIC_SUFFFIX, TRUE} from "../constants";
import {getLocale} from "../handler/LocaleHandler";
import {AssociateMetric, StowPackageMetric} from "../enums";
import {isCapabilityARorSSD} from "../Utility";
// import {getInductPackageMetrics} from "../resources/InductResource";

export const LOAD_METRICS_FOR_ROUTE_CALL_BEGIN = "LOAD_METRICS_FOR_ROUTE_CALL_BEGIN";
export const LOAD_STOW_PACKAGE_METRICS_FOR_ROUTE = "LOAD_STOW_PACKAGE_METRICS_FOR_ROUTE";
export const LOAD_PLANNED_PACKAGE_METRICS_FOR_ROUTE = "LOAD_PLANNED_PACKAGE_METRICS_FOR_ROUTE";
export const LOAD_INDUCT_PACKAGE_METRICS_FOR_ROUTE = "LOAD_INDUCT_PACKAGE_METRICS_FOR_ROUTE";
export const LOAD_STOW_ASSOCIATE_METRICS_FOR_ROUTE = "LOAD_STOW_ASSOCIATE_METRICS_FOR_ROUTE";
export const LOAD_METRICS_FOR_ROUTE_CALL_FAILURE = "LOAD_METRICS_FOR_ROUTE_CALL_FAILURE";

const metricProcessName = "SCC_STOW_ROUTE";

const loadMetricsForRouteCallBegin = () => ({
    type: LOAD_METRICS_FOR_ROUTE_CALL_BEGIN
});

const loadStowPackageMetricsForRoute = (stowPackageMetricsMap) => ({
    type: LOAD_STOW_PACKAGE_METRICS_FOR_ROUTE,
    stowPackageMetricsMap
});

const loadPlannedPackageMetricsForRoute = (plannedPackageMetricsMap) => ({
    type: LOAD_PLANNED_PACKAGE_METRICS_FOR_ROUTE,
    plannedPackageMetricsMap
});

/*const loadInductPackageMetricsForRoute = (inductPackageMetricsMap) => ({
    type: LOAD_INDUCT_PACKAGE_METRICS_FOR_ROUTE,
    inductPackageMetricsMap
});*/

const loadStowAssociateMetricsForRoute = (stowAssociateMetricsMap) => ({
    type: LOAD_STOW_ASSOCIATE_METRICS_FOR_ROUTE,
    stowAssociateMetricsMap
});

const loadMetricsForRouteCallFailure = () => ({
    type: LOAD_METRICS_FOR_ROUTE_CALL_FAILURE
});

function dedupeRouteIds(routesMap) {

    const routeCodeToId = {}

    for (const routeId in routesMap) {

        const route = routesMap[routeId];

        const oldRouteId = routeCodeToId[route.routeCode];

        //If two routeIds have same routeCode, we are keeping only the newer one
        if (!oldRouteId || oldRouteId.localeCompare(routeId, getLocale(), {numeric: true}) < 0) {
            routeCodeToId[route.routeCode] = routeId;
            if (oldRouteId) {
                delete routesMap[oldRouteId];
            }
        }
    }
}

export const getMetricsForRoute = (nodeId, capability) => {

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForRouteCallBegin());

            //fetch route-ids and planned package count
            const routesMap = await fetchPlannedPackageMetrics(nodeId);

            if (!isCapabilityARorSSD(capability)) {
                dedupeRouteIds(routesMap);
            }
            if (!routesMap) {
                dispatch(loadMetricsForRouteCallFailure());
            } else {
                dispatch(loadPlannedPackageMetricsForRoute(routesMap));

                const routeIds = Object.keys(routesMap);

                if (routeIds.length) {
                    //fetch stow package metrics
                    const stowPackageMetrics = await fetchStowPackageMetricsByRoute(nodeId, routeIds);
                    dispatch(loadStowPackageMetricsForRoute(stowPackageMetrics));

                    /* Dev pending

                    //fetch induct package metrics
                    const inductPackageMetrics = await fetchInductPackageMetricsByRoute(nodeId, routeIds);
                    dispatch(loadInductPackageMetricsForRoute(inductPackageMetrics));

                    */

                    //fetch stow associate metrics
                    const stowAssociateMetrics = await fetchStowAssociateMetricsByRoute(nodeId);
                    dispatch(loadStowAssociateMetricsForRoute(stowAssociateMetrics));
                }
            }

        } catch (error) {
            dispatch(loadMetricsForRouteCallFailure());
        }
    }
}

async function fetchPlannedPackageMetrics(nodeId) {

    const metricName = "getPlannedPackageMetrics";

    const request = {
        fieldsRequired: ["ID", "CODE"],
        filters: {
            NODE: [nodeId]
        }
    }

    const startTime = Date.now();
    const routesMap = await getStowRoutes(request);

    if (routesMap) {
        publishTime(metricProcessName, metricName, startTime);
        return routesMap;
    } else {
        publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
    }
}

async function fetchStowPackageMetricsByRoute(nodeId, routeIds) {
    const metricName = "fetchStowPackageMetricsByRoute";

    const request = {
        groupBy: "ROUTE_ID",
        filters: {
            NODE: [nodeId],
            ROUTE_ID: routeIds
        },
        metrics: [
            StowPackageMetric.STOW_RATE,
            StowPackageMetric.SCAN_COMPLIANCE,
            StowPackageMetric.PROBLEM_SOLVE_COUNT,
            StowPackageMetric.FSAF,
            StowPackageMetric.STOWED_COUNT,
            StowPackageMetric.CURRENT_INDUCTED_COUNT,
            StowPackageMetric.PLANNED_COUNT,
            StowPackageMetric.STOW_VS_PLAN
        ]
    }

    const startTime = Date.now();
    const stowPackageMetricsMap = await getStowPackageMetrics(request);

    if (stowPackageMetricsMap) {
        publishTime(metricProcessName, metricName, startTime);
        return stowPackageMetricsMap;
    } else {
        publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
    }
}

async function fetchStowAssociateMetricsByRoute(nodeId) {
    const metricName = "fetchStowAssociateMetricsByRoute";

    const request = {
        groupBy: "ROUTE_ID",
        filters: {
            NODE: [nodeId],
            DRS: [TRUE]
        },
        metrics: [
            AssociateMetric.ACTIVE_ASSOCIATE_COUNT,
            AssociateMetric.INACTIVE_ASSOCIATE_COUNT
        ]
    }

    const startTime = Date.now();
    const stowAssociateMetricsMap = await getStowAssociateMetrics(request);

    if (stowAssociateMetricsMap) {
        publishTime(metricProcessName, metricName, startTime);
        return stowAssociateMetricsMap;
    } else {
        publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
    }
}

/*async function fetchInductPackageMetricsByRoute(nodeId, routeIds) {

    const metricName = "fetchInductPackageMetricsByRoute";

    const request = {
        nodeId: nodeId,
        groupBy: "Cluster",
        metricList: ["RECEIVED"],
        filters: {
            'RouteId': routeIds
        }
    }

    const startTime = Date.now();
    const inductPackageMetricsMap = await getInductPackageMetrics(request);

    if (inductPackageMetricsMap) {
        publishTime(metricProcessName, metricName, startTime);
        return inductPackageMetricsMap;
    } else {
        publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
    }
}*/



// WEBPACK FOOTER //
// ./src/actions/RouteActions.js